import { FieldSchema } from "../../../Schema";
import { GridFilterTypes } from "../../../grid/AgGridManager";

export const updatedAt: FieldSchema = {
  name: "updatedAt",
  dataTransform: {
    toGraphql: undefined,
  },
  display: {
    displayed: false
  },
  form: { label: "Updated at", disabled: true, displayed: false },
  grid: {
    displayed: true,
    order: 67,
    label: "Last Edited Date",
    ignoredForSearch: true,
    // See createdAt: no `data` block, so the DATE filter and render slot must be explicit.
    filter: GridFilterTypes.DATE,
  },
};
